import * as React from 'react'
import { Fragment } from 'react';
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Redirect, NavLink as RouterNavLink } from 'react-router-dom';
import { Row, Col, Spinner, ListGroup, ListGroupItem, Button, 
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import BlobUtil from '../../utils/blobUtil'

interface IState {
    modal: boolean
    childTerm : string
    searchSorting : string
    searchSortingDisplay : string
    searchSortingDropDownOpen : boolean
    redirect: boolean
    redirectId: string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    selectedUserId : string
    term:string
    sorting:string
    totalDocument : number
    offset : number
    limit : number
    data: any[]
    loading: boolean
    downloading: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onLoadMore: any
    onSorting:any
    onDownload:any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListResult extends React.Component<AllProps, IState> {
    
    blobUtil: BlobUtil;

    sortList = [
        {"Display":"Course", "Expression":"c.courseTitle"},
        {"Display":"Last Watch", "Expression":"c.lastWatchDT desc"},
    ];
    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            childTerm : this.props.term,
            searchSortingDisplay: 'Course',
            searchSorting: this.props.sorting,
            searchSortingDropDownOpen: false,
            redirect: false,
            redirectId : ""
        };
        this.blobUtil = new BlobUtil();

        this.onInputChange = this.onInputChange.bind(this);
        this.onChangeSorting = this.onChangeSorting.bind(this);
        this.downloadCert = this.downloadCert.bind(this);
        //this.test = this.test.bind(this);
    }
    public componentDidMount() {
        
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.sorting != this.props.sorting){
            // if (this.props.sorting == ""){
            //     this.setState({ searchSortingDisplay: "Title" });
            // }
            this.setState({ searchSortingDisplay: this.SortExpressionDisplay(this.props.sorting) });
        }
    }

    onInputChange(e:any) {
        this.setState({ childTerm: e.target.value });
    }

    SortExpressionDisplay(sortExpression:string){
        let foundSort = this.sortList.find(e => e.Expression.toLowerCase() === sortExpression.toLowerCase());
        if (foundSort){
            return foundSort.Display;
        }else{
            return this.sortList[0].Display; // Get First
        }
    }

    onChangeSorting(e:any){
        var sortText = e.currentTarget.textContent;
        let foundSort = this.sortList.find(e => e.Display.toLowerCase() === sortText.toLowerCase());
        var sortExpression = "";
        if (foundSort){
            sortExpression = foundSort.Expression;
        }else{
            sortExpression = this.sortList[0].Expression; // Get First
        }
        this.setState({ 
            searchSortingDisplay : sortText, 
            searchSorting: sortExpression}, () => {
            this.props.onSorting(this.state);
        })
    }

    onRowSelected(id:string, e:any){
        this.setState({redirect : true, redirectId: id}, () => {
        });
    }

    

    constructCPDPoint(array: any) {
        let data: any = [];

        if (array){
            array.forEach((e: any) => {
                data.push(e.cpdRefNo + " (" + e.points + ")");
                // data.push("Engineer: 123");
            });
        }
        return data.join("\r\n");
    }
    
    async getCertUrl(oId:string, certFileName:string) {
        let blobRequestUrl = await this.blobUtil.GetBlob(oId ,certFileName);
        return blobRequestUrl;
    }

    async downloadCert(certFileName:string){
        if (this.props.selectedUserId !== undefined){
            let certURL = await this.getCertUrl(this.props.selectedUserId, certFileName);
            console.log("Cert URL:"+ certURL);
            window.open(certURL);
        }else{
            alert('Failed. Please go back to profile page.')
        }
    }

    SecondsTohhmmss(totalSeconds:number) {
        if (totalSeconds < 0){
            return "-";
        }

        totalSeconds = Math.trunc(totalSeconds);
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
        var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
      
        // round seconds
        seconds = Math.round(seconds * 100) / 100
      
        var result = (hours < 10 ? "0" + hours : hours);
            result += ":" + (minutes < 10 ? "0" + minutes : minutes);
            result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
        if (result === "00:00:00"){
            result = "-";
        }
        return result;
    }

    ExpiryDate(date: Date, days: number) {
        var expiryDate = new Date(date);
        //expiryDate.setDate(expiryDate.getDate() + days);
        expiryDate.setDate(expiryDate.getDate() + parseInt(String(days)));
        //console.log("Test:" + expiryDate);
        //var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
        var options = { year: 'numeric', month: 'short', day: 'numeric' } as const;
        return expiryDate.toLocaleDateString("en-US", options);
    }

    formatDateTime(date:string){
        if (date){
            var dt = new Date(date);
            var options = { year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit" } as const;
            return dt.toLocaleTimeString("en-US", options);
        }
    }  
    DaysRemaining(date: Date, days: number) {
        var expiryDate = new Date(date);
        // console.log(expiryDate);
        // console.log(expiryDate.getDate());
        expiryDate.setDate(expiryDate.getDate() + parseInt(String(days)));        //console.log(days);
        // var newExpiryDate = this.addDays(expiryDate, parseInt(days));
        //console.log(expiryDate);
        var today = new Date();
        if (expiryDate > today){
            const diffTime = Math.abs(expiryDate.getTime() - today.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            return diffDays + " day(s)";
        }else{
            return "-";
        }
    }
    
    GetImagePath(fileName: string){
        if (fileName && fileName !== ""){
            fileName = fileName.replace("/courses/","").replace(".jpg","_xs.jpg");
            return "https://images.ultimatespro.com/images/" + fileName;
        }  else {
            return "https://images.ultimatespro.com/images/general/empty_xs.png";
        }
    }
    public render() {  

        const renderCertColumn = (item:any) => {
            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();

            if(item.feedbackSubmitted){
                // Feedback Submitted, check if cert generated
                if (item.certIsGenerated){
                    return <Button color="secondary" 
                        onClick={this.downloadCert.bind(this, item.certFileName)} block
                        hidden={!item.certIsGenerated} >
                        Download
                    </Button>;
                }else{
                    return <span>Generating Cert</span>;
                }
            }else{
                if (item.playUntilSeconds >= item.courseDuration){
                   // Course completed but feedback not submitted, redirect to fill in feedback
                    return <Fragment>
                    <Link title="Feedback is required upon generating certificate" to={'/mycourses/feedback/' + item.id} className="btn btn-primary" >
                        Feedback</Link>
                    </Fragment>;
                    
                }else{
                    if (expiryDate < today){
                        return <span>Ineligible</span>;
                    }else{
                        return <span>Pending</span>;
                    }
                }
            }
        };    

        const renderStatus = (item:any) => {
            var remaining =  item.courseDuration - item.playUntilSeconds
    
            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();
    
            if (item.playUntilSeconds == 0){
                return <span>New</span>
            }else{
                if (remaining > 0){
                    if (expiryDate < today){
                        return <span>Incomplete</span>
                    }else{
                        return <span>Watching</span>
                    }
                }else{
                    return <span>Completed</span>
                }
            }
        }
        const renderPlay = (item:any) => {
            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();
            if (expiryDate < today){
                return <span>Expired</span>
            }else{
                return <Link to={'/mycourses/' + item.id} className="btn btn-success">Play</Link>
            }
        }
     
        const tdStyle = {
             padding : "15px"
          };

        const showLoadMore = (this.props.offset + this.props.limit) < this.props.totalDocument;
        const toggleSortingDropDown = () => this.setState({searchSortingDropDownOpen : !this.state.searchSortingDropDownOpen}); 

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/usercourses/' + this.state.redirectId
                }} />
            )
        }
        else{
            return (
                <div onScroll={this.props.onLoadMore.bind(this, this.state)}>
                    <ListGroup>
                        <ListGroupItem>
                            <Row>
                                <Col lg="9" >
                                    <span>{this.props.totalDocument} result(s)</span>&nbsp;
                                    <Button color="warning" onClick={this.props.onDownload} disabled={this.props.downloading}><i className="fas fa-download mr-1"></i>Download file</Button> 
                                    <Spinner color="danger" hidden={!this.props.downloading} />
                                </Col>
                                <Col lg="3" >
                                    <Dropdown isOpen={this.state.searchSortingDropDownOpen} toggle={toggleSortingDropDown}>
                                        <DropdownToggle caret color="secondary" block>
                                            <i className="fas fa-sort mr-1"></i>
                                            {this.state.searchSortingDisplay}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem header>Sort</DropdownItem>
                                            <DropdownItem divider/>
                                            {
                                                this.sortList.map(item =>(
                                                    <DropdownItem onClick={this.onChangeSorting}>{item.Display}</DropdownItem>
                                                ))
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </ListGroupItem>
                        <Table>
                            <thead>
                                <tr style={{whiteSpace: "nowrap"}}>
                                    <th>#</th>
                                    {/* <th>Order #</th> */}
                                    <th>Course Ref#</th>
                                    <th>CPD Ref/Points</th>
                                    <th>Remaining days</th>
                                    <th>Expiry Date</th>
                                    <th>Duration</th>
                                    <th>Remaining</th>
                                    <th>Last Watch</th>
                                    <th>Status</th>
                                    <th>Verification</th>
                                    <th>Cert</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.props.data.length>0 ? (
                                    this.props.data.map(item =>(
                                        <Fragment key={item.id}>
                                            {/* <tr key={item.id} onClick={this.onRowSelected.bind(this, item.id)}> */}
                                            <tr key={item.id + "-1"}>
                                                <th scope="row" rowSpan={2}>
                                                    <img src={this.GetImagePath(item.videoThumbnailURL)} width="100px" />
                                                </th>
                                                <td colSpan={10} style={{fontWeight: "bolder"}}>
                                                    {/* <Link to={'/mycourses/' + item.id}>{item.courseTitle}</Link> */}
                                                    {item.courseTitle}
                                                </td>
                                            </tr>
                                            <tr key={item.id + "-2"}>
                                                {/* <td>
                                                    {item.orderId}
                                                </td> */}
                                                <td>
                                                    {item.refNo}
                                                </td>
                                                <td style={{fontSize:"smaller"}}>
                                                    {this.constructCPDPoint(item.cpdPoints)}
                                                </td>
                                                <td>
                                                    {this.DaysRemaining(item.orderDT, item.shelfLifeDays)}
                                                </td>
                                                <td>
                                                    {this.ExpiryDate(item.orderDT, item.shelfLifeDays)}
                                                </td>
                                                <td>
                                                    {this.SecondsTohhmmss(item.courseDuration)}
                                                </td>
                                                <td>
                                                    {this.SecondsTohhmmss(item.courseDuration - item.playUntilSeconds)}
                                                </td>
                                                <td>
                                                    {this.formatDateTime(item?.lastWatchDT)}
                                                </td>
                                                <td>
                                                    {renderStatus(item)}
                                                </td>
                                                <td>
                                                    {item?.verificationType == "noVerification" ? "No" : "Yes"}
                                                </td>
                                                <td>
                                                    {renderCertColumn(item)}
                                                </td>
                                                <td style={{width:"100px"}}><RouterNavLink to={"/users/" + this.props.selectedUserId +  "/courses/" + item.id}><Button color="primary"><i className="fas fa-eye mr-1"></i>View</Button></RouterNavLink></td>
                                            </tr>
                                        </Fragment>
                                    ))
                                    ) : (
                                        <Fragment>
                                            <tr><td colSpan={12}><span>User yet to subscribe any course</span></td></tr>
                                        </Fragment>
                                    )
                                }
                            </tbody>
                        </Table>
                        <ListGroupItem key="loadmore">
                            <Row>
                                <Col lg="12">
                                    <Spinner color="warning" hidden={!this.props.loading} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Button color="secondary" 
                                        onClick={this.props.onLoadMore.bind(this, this.state)} block
                                        hidden={!showLoadMore} >
                                        Load More
                                    </Button>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </div>
            )
        }
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {

}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListResult)